import type {
  AdminSetUserPasswordInput,
  IAuthRepository,
} from '@/features/authentication/domain/repositories/IAuthRepository.js';

export function createAdminSetUserPasswordUseCase(deps: { authRepository: IAuthRepository }) {
  return (input: AdminSetUserPasswordInput): Promise<void> =>
    deps.authRepository.adminSetUserPassword(input);
}
